import {useEffect, useMemo, useState } from "react"
import { Input, Button, Table,  Select, DatePicker, Modal,  TreeSelect, message, Row, Col, Statistic } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import BreadCrumb from '../../component/BreadCrumb'
import _ from 'lodash'
import { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from "../../tool/axios"
import { CheckImgs } from "../../component/common/Imgs"
import { SelectStores } from "../../component/common/Selects"
import getPermission from '../../js/permission'
import { Link } from "react-router-dom"
import moment from "moment"

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker


type fetchParams = {
    expect_born_month: any,
    actually_born_month:any,
    store_id: string | undefined,
    check_in_status: number | undefined,
    belong_look_after_id: string | undefined,
    check_in_user_name: string | undefined,
    check_in_phone: number | undefined,
    preg_status: number | undefined,
    expectBornDay: any,
    actuallyBornDay: any,
    checkInDay: any,
    checkOutDay: any,
    has_continue: number | undefined,
    nursing_care_type: number | undefined
    room_number: number | undefined
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

interface ep {
    "employee_id": string,
    "user_name": string
}


export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        expect_born_month: null,
        actually_born_month:null,
        store_id: undefined,
        check_in_status: undefined,
        belong_look_after_id:  undefined,
        check_in_user_name: undefined,
        check_in_phone: undefined,
        room_number: undefined,
        preg_status: undefined,
        expectBornDay: null,
        actuallyBornDay: null,
        checkInDay: null,
        checkOutDay: null,
        has_continue: undefined,
        nursing_care_type: undefined
    }

    // 各类型客服总数
    const [dataTotals,setDataTotals] = useState<{type:number,total:number,url:string}[]>([
        {type:0,total:0,url:'/nursing/customer/page_list'}
    ])
    const [currentType,setCurrentType] = useState<number>(0)

    const [urls, setUrls] = useState<string[]>([])
    const [swiperVisible, setSiperVisible] = useState<boolean>(false)

    const [gjData,setGjData] = useState<ep[]>([])
    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: false
    })
    const [data, setData] = useState<any>([])
    const [loading, setLoading] = useState<boolean>(false)

    const [inStoreRecordVisible, setInStoreRecordVisible] = useState<boolean>(false)
    const [inStoreRecordData, setInStoreRecordData] = useState<any[]>([])

    const [followRecordVisible, setFollowRecordVisible] = useState<boolean>(false)
    const [followRecordData, setFollowRecordData] = useState<any[]>([])

    const [inMoneyRecordVisible, setInMoneyRecordVisible] = useState<boolean>(false)
    const [inMoneyRecordData, setInMoneyRecordData] = useState<any>({ "total_agreement_amount": 0, "total_review_amount": 0, "total_pay_amount": 0, pay_records_list: [] })

    const [lossVisible, setLossVisible] = useState<boolean>(false)
    const [lossData, setLossData] = useState<any[]>([])

    const permission: string[] = useMemo(() => {
        console.log(getPermission())
        return getPermission()
    }, [window.location.pathname])

    
    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value
        setFetchOtherParams(params)
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)
        let p: any = { ...pagination }
        p.current = 1
        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current
        setPagination(p)
    }

    function handleDate(param: any, attr: string, realDateParams: string[]): void {
        if (param[attr]) {
            param[realDateParams[0]] = param[attr][0].format('YYYY-MM-DD')
            param[realDateParams[1]] = param[attr][1].format('YYYY-MM-DD')
            delete param[attr]
        }
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)
        const iPagination: any = { ...pagination }
        iPagination.size = iPagination.pageSize
        iPagination.page = iPagination.current
        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.current

        let params: any = { ...fetchOtherParams }

        if(currentType===0){
            // handleDate(params, 'expectBornDay', ['expect_born_start_day', 'expect_born_end_day'])
            // handleDate(params, 'actuallyBornDay', ['actually_born_start_day', 'actually_born_end_day'])
            handleDate(params, 'checkInDay', ['check_in_start_day', 'check_in_end_day'])
            handleDate(params, 'checkOutDay', ['check_out_start_day', 'check_out_end_day'])
        }else{
            params = null
        }

        axiosTable.get(dataTotals[currentType].url, {
            params: {
                ...iPagination,
                ...params
            }
        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total
                let d = [...dataTotals]
                d[currentType].total = response.total
                setDataTotals(d)
                setPagination(p)
                setData(response.records)
            }
            setLoading(false)
        })
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1
        fetch({ pagination: p, fetchOtherParams })
    }


    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])


    const exportExcel = () => {

        message.success('此次导出需要较长时间，请稍等..')

        const iPagination: any = { ...pagination }
        iPagination.size = iPagination.pageSize
        iPagination.page = iPagination.current
        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.current
        delete iPagination.showSizeChanger

        let params: any = { ...fetchOtherParams }
        if(currentType===0){
            // handleDate(params, 'expectBornDay', ['expect_born_start_day', 'expect_born_end_day'])
            // handleDate(params, 'actuallyBornDay', ['actually_born_start_day', 'actually_born_end_day'])
            handleDate(params, 'checkInDay', ['check_in_start_day', 'check_in_end_day'])
            handleDate(params, 'checkOutDay', ['check_out_start_day', 'check_out_end_day'])
        }else{
            params = null
        }

        baseAxiosComplete('/keeper/check_in/export', {
            params: {
                ...iPagination,
                ...params
            }
        }).then(res => {
            if (res.status === 0) {
                window.open(res.data)
            }
        })
    }

    const recursionChildren = (children: any[]) => {
        let childArr: any = []

        children.forEach((el: any) => {
            childArr.push({
                title: el.channel_name,
                value: el.id,
                key: el.id,
                children: el.children && recursionChildren(el.children)
            })
        })

        return childArr
    }


    return (<div className="common-page">
        <BreadCrumb position={['护理中心', '入住客房管理']} />
        <div className="common-top-form">
            
        {/* <Row gutter={16} style={{ marginBottom: 20, marginLeft: 20 }}>
            <Select  className="fl" virtual={false} style={{ width: 150, marginRight: 12, marginBottom: 12 }} placeholder="筛选客户" value={currentType} onChange={(v:number)=>{
                setCurrentType(v)
            }}>
                <Option value={0} key={0}>全部</Option>
                <Option value={1} key={1}>待分配客户</Option>
                <Option value={2} key={2}>待入住客户</Option>
                <Option value={3} key={3}>已入住客户</Option>
                <Option value={4} key={4}>本月已出所客户</Option>
                <Option value={5} key={5}>本月待产客户</Option>
                <Option value={6} key={6}>需回访客户</Option>
                <Option value={7} key={7}>3天内出所客户</Option>
            </Select>
        </Row> */}
            <div className="clear">
                <div className="fl" style={{marginRight:12}}>
                <SelectStores onChange={(value: string) => {
                    handleChange(value, 'store_id') 
                    baseAxiosNoInfo('/global/employee_list_by_position',{params:{
                        department_id:value,
                        position_number:'38'
                    }}).then((res:any)=>{
                        res && setGjData(res)
                    })
                }} 
                value={fetchOtherParams.store_id}  />
                </div>
                <Select allowClear className="fl" virtual={false} style={{ width: 150, marginRight: 12, marginBottom: 12 }} placeholder="入住状态" value={fetchOtherParams.check_in_status} onChange={(v: number) => { handleChange(v, 'check_in_status') }}>
                    <Option value={1} key={1}>已预订</Option>
                    <Option value={2} key={2}>已入住</Option>
                    <Option value={3} key={3}>已出所</Option>
                </Select>
                <Input className="fl" style={{ width: '120px', marginRight: 12, marginBottom: 12 }} placeholder="入住人名称" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'check_in_user_name') }} value={fetchOtherParams.check_in_user_name} />
                <Input className="fl" style={{ width: '120px', marginRight: 12, marginBottom: 12 }} placeholder="入住人手机号" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'check_in_phone') }} value={fetchOtherParams.check_in_phone} />
                <Input className="fl" style={{ width: '120px', marginRight: 12, marginBottom: 12 }} placeholder="房号" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'room_number') }} value={fetchOtherParams.room_number} />
                
                <Select allowClear className="fl" virtual={false} style={{ width: 150, marginRight: 12, marginBottom: 12 }} placeholder="怀孕状态" value={fetchOtherParams.preg_status} onChange={(v: number) => { handleChange(v, 'preg_status') }}>
                    <Option value={1} key={1}>正在备孕</Option>
                    <Option value={2} key={2}>已经怀孕</Option>
                    <Option value={3} key={3}>已有宝宝</Option>
                    <Option value={4} key={4}>小月子</Option>
                    <Option value={5} key={5}>孕早期</Option>
                    <Option value={6} key={6}>孕中期</Option>
                    <Option value={7} key={7}>孕晚期</Option>
                    <Option value={8} key={8}>预产期前7天</Option>
                    <Option value={9} key={9}>已分娩</Option>
                    <Option value={10} key={10}>超出预产期</Option>
                    <Option value={0} key={0}>未知</Option>
                </Select>
                <RangePicker style={{ marginRight: 12, marginBottom: 12, width: 360 }} className="fl" placeholder={["入住日期开始日期", "入住日期结束日期"]} value={fetchOtherParams.checkInDay} onChange={(v: any) => { handleChange(v, 'checkInDay') }} />
                <RangePicker style={{ marginRight: 12, marginBottom: 12, width: 360 }} className="fl" placeholder={["出所日期开始日期", "出所日期结束日期"]} value={fetchOtherParams.checkOutDay} onChange={(v: any) => { handleChange(v, 'checkOutDay') }} />
                {/* <Select allowClear className="fl" virtual={false} style={{ width: 150, marginRight: 12, marginBottom: 12 }} placeholder="是否续住" value={fetchOtherParams.has_continue} onChange={(v: number) => { handleChange(v, 'has_continue') }}>
                    <Option value={1} key={1}>是</Option>
                    <Option value={0} key={0}>否</Option>
                </Select> */}
                <DatePicker className="fl"  style={{marginRight:12}}allowClear onChange={(v:any)=>{
                    let s = _.cloneDeep(fetchOtherParams)
                    if(v){
                        s.expect_born_month	 = moment(v).format('YYYY-MM')
                    }else{
                        s.expect_born_month	 = null
                    }
                    setFetchOtherParams(s)
                }} picker="month" placeholder="预产月份" value={fetchOtherParams.expect_born_month ? moment(fetchOtherParams.expect_born_month): null}  />
                
                <DatePicker className="fl" placeholder="分娩月份" style={{marginRight:12}} allowClear onChange={(v:any)=>{
                    let s = _.cloneDeep(fetchOtherParams)
                    if(v){
                        s.actually_born_month	 = moment(v).format('YYYY-MM')
                    }else{
                        s.actually_born_month	 = null
                    }
                    setFetchOtherParams(s)
                }} picker="month" value={fetchOtherParams.actually_born_month ? moment(fetchOtherParams.actually_born_month): null}  />
                <Select allowClear className="fl" virtual={false} style={{ width: 150, marginRight: 12, marginBottom: 12 }} placeholder="护理模式" value={fetchOtherParams.nursing_care_type} onChange={(v: number) => { handleChange(v, 'nursing_care_type') }}>
                    <Option value={0} key={0}>未知</Option>
                    <Option value={1} key={1}>一对一</Option>
                    <Option value={2} key={2}>托管</Option>
                </Select>
                <Select  className="fl"  virtual={false} style={{ width:'190px',marginRight:12,marginBottom:12 }} placeholder="护理师（先选门店）"  onChange={(e: string) => { handleChange(e, 'belong_look_after_id') }} value={fetchOtherParams.belong_look_after_id}>
                        {gjData.map((el:ep)=><Option value={el.employee_id} key={el.user_name}>{el.user_name}</Option>)}
                </Select>
                {permission.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn fl" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>}
                <Button className="fl" style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                {permission.includes('导出') &&<Button className="fl" onClick={() => { exportExcel() }} type="dashed" >导出</Button>}
            </div>
        </div>
        <div className="common-main">
            <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="id" pagination={pagination} onChange={handleTableChange}>
                <Column  fixed title="操作" render={(row: any) => {
                    return permission.includes('查看详情') ? <Link to={'/nursing_check_in_detail/'+row.id} >查看详情</Link> : null
                }} />
                <Column fixed title="入住人"  dataIndex="check_in_user_name" key="check_in_user_name" />
                <Column fixed title="联系电话"  dataIndex="check_in_phone" key="check_in_phone" />
                <Column fixed title="签单套餐"  dataIndex="deal_item_name" key="deal_item_name" />
                <Column  title="护理模式描述"  dataIndex="nursing_care_type_desc" key="nursing_care_type_desc" />
                <Column  title="护理师"  dataIndex="belong_look_after_name" key="belong_look_after_name" />
                <Column  title="责任护士"  dataIndex="belong_nurse_name" key="belong_nurse_name" />
                <Column title="怀孕时期" dataIndex="preg_status_desc" key="preg_status_desc" />
                <Column title="预产期" dataIndex="expect_born_day" key="expect_born_day" />
                <Column title="分娩日" dataIndex="actually_born_day" key="actually_born_day" />
                <Column  title="入住门店" dataIndex="check_in_store_name" key="check_in_store_name" />
                <Column  title="入住状态"  dataIndex="check_in_status_desc" key="check_in_status_desc" />
                <Column  title="入住房号"  dataIndex="room_number" key="room_number" />
                <Column  title="预住天数" dataIndex="check_in_total_days" key="check_in_total_days" />
                <Column  title="已住天数" dataIndex="check_in_already_days" key="check_in_already_days" />
                <Column  title="剩余天数" dataIndex="check_in_left_days" key="check_in_left_days" />
                <Column  title="入住时间" dataIndex="check_in_time" key="check_in_time" />
                <Column  title="出所日期" dataIndex="check_out_time" key="check_out_time" />
            </Table>
        </div>

        <CheckImgs tinyURL={urls} visible={swiperVisible} onCancel={() => { setSiperVisible(false) }} />
    </div>)
}